import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowDownRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowDownRight"><Path fillRule="evenodd" clipRule="evenodd" d="M6.50023 4.37866L16.0002 13.8787V7.99998H19.0002V19H8.00023V16H13.8789L4.37891 6.49998L6.50023 4.37866Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowDownRight;
